import IdGenerator from 'scripts/domain/contracts/id_generator';
import mixin from '../../lib/mixin';
import Observable from '../../lib/observable_mixin';
import qconsole from 'scripts/lib/qconsole';

const DEFAULT_TIMEOUT = 30000; // 30s

export default class CustomerAutoExtensionGateway {
  constructor(http, requestorId) {
    this.http = http;
    this.requestorId = requestorId;
  }

  init({ orgId } = {}) {
    this.orgId = orgId;
  }

  url(customerId) {
    return `/api/v2/orgs/${this.orgId}/customer-auto-extensions/${customerId}`;
  }

  update(customerId, payload) {
    const correlationId = IdGenerator.newId();
    this.http.post(this.url(customerId), payload, this.handleUpdateResponse.bind(this, customerId, correlationId), {
      timeout: DEFAULT_TIMEOUT,
      headers: { 'Gladly-Correlation-Id': correlationId, 'Gladly-Requestor-Id': this.requestorId },
    });

    return { correlationId };
  }

  handleUpdateResponse(customerId, correlationId, err, res) {
    if (err != null) {
      qconsole.error('error during external customer extension: ', err);
      this.notifyObservers('handleExtensionErrors', { customerId, correlationId, errors: err });
    } else if (res.status >= 200 && res.status < 300) {
      this.notifyObservers('handleExtensionSuccess', { customerId, correlationId, resultDto: res.response });
    } else {
      this.notifyObservers('handleExtensionErrors', { customerId, correlationId, errors: res.response });
    }
  }
}

mixin(CustomerAutoExtensionGateway.prototype, Observable);
